(function () {
  'use strict';

  var FLAG_KEY = 'woodypanel_pdp_atc';
  var PAYLOAD_KEY = 'woodypanel_maak_compleet_data';
  var FLAG_TTL_MS = 10000;

  // B2B-klanten (BSS B2B app, tag "b2b") slaan de maak-compleet tussenstap
  // over: die pagina toont B2C-prijzen. Zonder stash volgt geen redirect en
  // opent gewoon de winkelwagen/notificatie met de juiste B2B-prijzen.
  function isB2BCustomer() {
    try {
      var c = window.BSS_B2B && window.BSS_B2B.shopData && window.BSS_B2B.shopData.customer;
      if (!c) return false;
      if (c.isB2B === true) return true;
      var tags = c.tags || [];
      for (var i = 0; i < tags.length; i++) {
        if (String(tags[i]).toLowerCase().indexOf('b2b') === 0) return true; // b2b, b2b-vast, b2b-instap
      }
      return false;
    } catch (e) {
      return false;
    }
  }

  function readConfig() {
    var el = document.querySelector('script[data-pdp-complete-config]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function stashPayload(config, variantId) {
    try {
      sessionStorage.setItem(PAYLOAD_KEY, JSON.stringify({
        product: config.product,
        sections: config.sections,
        bundle: config.bundle || null,
        triggerVariantId: variantId || null
      }));
      sessionStorage.setItem(FLAG_KEY, JSON.stringify({
        ts: Date.now(),
        productId: config.product.id,
        variantId: variantId || null,
        redirectUrl: config.redirectUrl
      }));
    } catch (e) {}
  }

  function readFlag() {
    try {
      var raw = sessionStorage.getItem(FLAG_KEY);
      if (!raw) return null;
      var flag = JSON.parse(raw);
      if (!flag || typeof flag.ts !== 'number') return null;
      if (Date.now() - flag.ts > FLAG_TTL_MS) {
        sessionStorage.removeItem(FLAG_KEY);
        return null;
      }
      return flag;
    } catch (e) {
      return null;
    }
  }

  function clearFlag() {
    try { sessionStorage.removeItem(FLAG_KEY); } catch (e) {}
  }

  window.WoodypanelMaakCompleet = {
    // Returns true if it handled the post-ATC flow (i.e. started a redirect),
    // so theme.js knows to skip opening the cart drawer.
    maybeRedirectAfterAtc: function () {
      var flag = readFlag();
      if (!flag) return false;
      clearFlag();
      var url = flag.redirectUrl + '?id=' + encodeURIComponent(flag.productId);
      if (flag.variantId) url += '&variant=' + encodeURIComponent(flag.variantId);
      window.location.href = url;
      return true;
    }
  };

  function attachSubmitListener(config) {
    var configScript = document.querySelector('script[data-pdp-complete-config]');
    if (!configScript) return;
    var configSection = configScript.closest('.shopify-section');

    // TMS theme uses the <product-form> custom element wrapping a native <form>
    // (Dawn 15.x), not the legacy form[is="product-form"] pattern.
    document.querySelectorAll('product-form form').forEach(function (form) {
      var section = form.closest('.shopify-section');
      if (section !== configSection) return;
      // Voorkom dubbel binden na een live variant-swap (variant-swap.js).
      if (form.dataset.mcBound) return;
      form.dataset.mcBound = '1';

      form.addEventListener('submit', function () {
        if (!config.active) return;
        if (isB2BCustomer()) return;
        var variantInput = form.querySelector('[name="id"]');
        var variantId = variantInput ? variantInput.value : null;
        stashPayload(config, variantId);
      }, { capture: true });
    });
  }

  function init() {
    var config = readConfig();
    if (!config) return;
    attachSubmitListener(config);
  }

  // Laat variant-swap.js de listener opnieuw binden op het verse formulier na een
  // live variant-swap (idempotent dankzij de mcBound-guard hierboven).
  window.WoodypanelMaakCompleet.reinit = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
